// extracted by mini-css-extract-plugin
export var fullWidthButton = "_d0-0";